
<!--改制目录到物料 新增/修改/查看-->
<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reformToMaterial',title:'改制目录到物料'},{title:pageTitle}]"/>
        <div class="h-content" :class="{'h-view-mode': isView}">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="saveData" label-position="right" ref="saveData" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>{{ pageTitle }}</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine edit-reform-to-material">
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input placeholder="请输入" v-model="saveData.materialCode"  @change="selectModel" :disabled="isView"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="saveData.materialName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制要求" class="h-elformWrap-2" prop="specificReform">
                                                <el-input placeholder="请输入" v-model="saveData.specificReform" :disabled="isView"></el-input>
                                            </el-form-item>
                                            <el-form-item label="个性化定制标准描述" class="h-elformWrap-2" prop="individualizeReform">
                                                <el-input placeholder="请输入" v-model="saveData.individualizeReform" :disabled="isView"></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否只能生产改" class="h-elformWrap-2" prop="onlyProduction">
                                                <el-select v-model="saveData.onlyProduction" placeholder="请选择" clearable :disabled="isView">
                                                    <el-option label="是" :value="1"></el-option>
                                                    <el-option label="否" :value="0"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="单台加价" class="h-elformWrap-2" prop="reformPrice">
                                                <el-input placeholder="请输入" v-model="saveData.reformPrice" :disabled="isView"
                                                          oninput="value=value.replace(/[^\d.]/g,'').replace(/^(\d+)\.(\d{0,2}).*$/,'$1.$2')"></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制技术要求" class="h-elformWrap-1" prop="reformCountRequire">
                                                <el-input placeholder="请输入" v-model="saveData.reformCountRequire" :disabled="isView"></el-input>
                                            </el-form-item>

                                            <el-form-item prop="remark" label="备注"  class="h-elformWrap-1">
                                                    <el-input v-model="saveData.remark" placeholder="请输入" :disabled="isView"></el-input>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>

                    <!-- 改制物料明细（子表） -->
                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>改制物料明细</h1>
                                </div>
                            </div>
                            <el-table
                                ref="detailTable"
                                :data="saveData.detailList"
                                stripe                                style="width: 100%"
                                :border="true">
                                <el-table-column type="index" width="50" label="#"></el-table-column>

                                <el-table-column prop="addMaterialCode" label="改制新增物料号" min-width="140">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.addMaterialCode" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="addMaterialName" label="新增物料名称" min-width="140">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.addMaterialName" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="addMaterialOrder" label="新增物料单耗" min-width="120">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.addMaterialOrder" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="replaceMaterialCode" label="替换物料号" min-width="140">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.replaceMaterialCode" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="replaceMaterialName" label="替换物料名称" min-width="140">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.replaceMaterialName" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="replaceMaterialOrder" label="替换物料单耗" min-width="120">
                                    <template slot-scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.replaceMaterialOrder" placeholder="请输入" :disabled="isView"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="!isView" label="操作" fixed="right" width="100">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" class="h-tableLink h-btn" style="color:#f56c6c;" @click="delDetail(scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="h-tableAdd" v-if="!isView" @click="addDetail">
                                <a>添加一行</a>
                            </div>
                        </div>
                    </div>
                </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="saveData.instid"/>
            </div>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>
                <el-button v-if="!isView" class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage">{{ resubmit ? '重新提交' : '提交' }}</el-button>
                <el-button v-if="saveData.instid" class="el-button h-btn el-button--default"
                           @click="viewpress">审批跟踪
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>import reformToMaterial from "@/api/reformToMaterial/reformToMaterial";
import ss from "@/api/SystemService";

export default {
    data() {
        return {
            id: '',
            isView: false,
            //流程参数:待办打开时携带
            taskid: null,
            instid: null,
            taskstatus: null,
            chongXinTiJiao: null,
            //驳回后从待办进入(重新提交)
            resubmit: false,
            showhistory: false,
            saveData: {
                id: '',
                materialCode: '',
                materialName: '',
                specificReform: '',
                individualizeReform: '',
                onlyProduction: null,
                reformPrice: '',
                detailList: [
                    this.createDetailRow()
                ],
            },
            rules: {
                materialCode: [{ required: true, message: '请输入产品编码', trigger: 'blur' }],
                specificReform: [{ required: true, message: '请输入改制要求', trigger: 'blur' }],
                individualizeReform: [{ required: true, message: '请选择是否只能生产改', trigger: 'change' }],
                onlyProduction: [{ required: true, message: '请选择是否只能生产改', trigger: 'change' }],
                reformPrice: [
                    { required: true, message: '请输入单台加价', trigger: 'blur' },
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '单台加价只能为数字，且最多两位小数', trigger: 'blur' }
                ],
            },
        }
    },
    computed: {
        pageTitle() {
            if (this.isView) {
                return '改制目录到物料详情';
            }
            if (this.resubmit) {
                return '重新提交改制目录到物料';
            }
            return this.id ? '修改改制目录到物料' : '新增改制目录到物料';
        }
    },
    created() {
        //待办打开时的参数:ywid为主键,taskid/instid/taskstatus为流程参数,chongXinTiJiao=1为驳回后重新提交
        this.id = this.$route.query.ywid || this.$route.query.id || '';
        this.taskid = this.$route.query.taskid;
        this.instid = this.$route.query.instid;
        this.taskstatus = this.$route.query.taskstatus;
        this.chongXinTiJiao = this.$route.query.chongXinTiJiao;
        this.isView = this.$route.query.viewMode == 1;
        //已办结的待办只能查看
        if (this.taskstatus == '1' && this.$route.query.viewMode == undefined) {
            this.isView = true;
        }
        //驳回后从待办进入:带流程实例信息 -> 重新提交
        this.resubmit = !this.isView && (this.chongXinTiJiao == 1 || (!!this.instid && !!this.taskid));
        if (this.id) {
            this.getDetail(this.id);
        }
    },
    methods: {
        // 生成一行子表明细
        createDetailRow() {
            return {
                addMaterialCode: '',
                addMaterialName: '',
                addMaterialOrder: '',
                replaceMaterialCode: '',
                replaceMaterialName: '',
                replaceMaterialOrder: '',
            };
        },
        // 添加一行
        addDetail() {
            this.saveData.detailList.push(this.createDetailRow());
        },
        // 删除一行
        delDetail(index) {
            this.$confirm('确认删除该行？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                if (this.saveData.detailList.length > 1) {
                    this.saveData.detailList.splice(index, 1);
                } else {
                    this.$message.warning('至少保留一行');
                }
            }).catch(() => {});
        },
        selectModel(code) {
            ss.salesList.selectModel(code).then(rd => {
                if(rd){
                    this.saveData.materialName =rd.promodel;

                }else{
                    this.$msg.msge("该物料在销售样表中不存在,请先维护销售样表");
                }
            })
        },

        // 获取详情（修改/查看）
        getDetail(id) {
            reformToMaterial.selectById(id).then(rd => {
                if (rd.obj !== null && rd.obj !== undefined) {
                    this.saveData = rd.obj;
                    if (!this.saveData.detailList || this.saveData.detailList.length === 0) {
                        this.$set(this.saveData, 'detailList', [this.createDetailRow()]);
                    }
                    //当前数据是驳回状态(4):无论从待办还是列表进入,都按重新提交处理
                    if (!this.isView && (this.saveData.status == 4 || this.saveData.status == '4')) {
                        this.resubmit = true;
                    }
                    //流程参数兜底取数据上的值
                    if (!this.instid) {
                        this.instid = this.saveData.instid;
                    }
                    if (!this.taskid) {
                        this.taskid = this.saveData.taskid;
                    }
                }
            })
        },
        // 返回
        quxiao() {
            this.$router.go(-1);
        },
        // 保存(新增/修改/重新提交)
        submitFlage() {
            this.$refs.saveData.validate(valid => {
                if (!valid) {
                    this.$msg.msge("请完善信息后再提交！");
                    return;
                }
                if (this.resubmit) {
                    this.resubmitTo();
                    return;
                }
                if (this.id) {
                    this.updateTo();
                } else {
                    this.saveTo();
                }
            })
        },
        saveTo() {
            reformToMaterial.insert(this.saveData).then(rd => {
                this.$msg.msgs(rd.msg);
                if (rd.f) {
                    this.quxiao();
                }
            })
        },
        updateTo() {
            reformToMaterial.updateById(this.saveData).then(rd => {
                this.$msg.msgs(rd.msg);
                if (rd.f) {
                    this.quxiao();
                }
            })
        },
        // 驳回后重新提交:带上流程参数,保存后流程重新流转
        resubmitTo() {
            this.saveData.taskid = this.taskid;
            this.saveData.instid = this.instid;
            this.saveData.submitflag = '重新提报';
            reformToMaterial.updateById(this.saveData).then(rd => {
                this.$msg.msgs(rd.msg);
                if (rd.f) {
                    //刷新右上角的待办个数
                    this.$store.dispatch("searchTasktotal");
                    this.quxiao();
                }
            })
        },
        viewpress(r) {
            this.showhistory = true;
        },
    }
}
</script>
<style>.edit-reform-to-material .h-elformWrap-2 .el-form-item__label {
    width: 45%;
    text-align: right;
}

.edit-reform-to-material .el-form-item__content {
    width: 55%;
}

.edit-reform-to-material .h-elformWrap-2 {
    width: 33.333% !important;
    padding-right: 0.5rem;
}

.edit-reform-to-material .h-elformWrap-3 {
    width: 33.333% !important;
    padding-right: 0.5rem;
}

.edit-reform-to-material .h-elformWrap-3 .el-form-item__label {
    width: 45%;
    text-align: right;
}

.edit-reform-to-material .h-elformWrap-1 {
    width: 100%;
    padding-right: 0.5rem;
}

.edit-reform-to-material .h-elformWrap-1 .el-form-item__label {
    width: 14%;
}

.edit-reform-to-material .h-elformWrap-1 .el-form-item__content {
    width: 86%;
}

.edit-reform-to-material .el-form-item__content .el-select {
    width: 100%;
}

.ljjtablepaddings12 .h-tableInput .el-input__inner {
    padding: 0.05rem 0.1rem;
}

.ljjtablepaddings12 .h-tableInput .el-input__icon {
    line-height: 0.25rem;
}

.h-view-mode .el-input__inner,
.h-view-mode .el-textarea__inner {
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.h-view-mode .h-tableAdd {
    display: none;
}

.h-view-mode .h-tableLink {
    display: none;
}
</style>
